import components from "./components/index.js";
import pages from "./pages/index.js";
import initRecaptcha from "./recaptcha.js";
import forms from "@/js/forms";

window.addEventListener("DOMContentLoaded", () => {
    components();
    pages();
    initRecaptcha();
    forms();
});
